// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DateUtils from "../../utils/DateUtils.bs.jsx";
import * as ReactIntl from "react-intl";
import * as Stdlib_Math from "@rescript/runtime/lib/es6/Stdlib_Math.js";
import * as JsxRuntime from "react/jsx-runtime";

function FormattedDateTimeShort(props) {
  let value = props.value;
  let now = new Date();
  let todayEOD = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1 | 0);
  let differenceInDays = Stdlib_Math.Int.floor((todayEOD.getTime() - value.getTime()) / DateUtils.dayInMilliseconds);
  switch (differenceInDays) {
    case 0 :
      return <ReactIntl.FormattedTime
        value={value}
        hour={"numeric"}
        minute={"numeric"}
      />;
    case 1 :
      return <>
        {"včera\xA0"}
        <ReactIntl.FormattedTime
          value={value}
          hour={"numeric"}
          minute={"numeric"}
        />
      </>;
    case 2 :
      return <>
        {"předevčírem\xA0"}
        <ReactIntl.FormattedTime
          value={value}
          hour={"numeric"}
          minute={"numeric"}
        />
      </>;
    case 3 :
    case 4 :
    case 5 :
    case 6 :
      break;
    default:
      return <ReactIntl.FormattedDate
        value={value}
        weekday={"short"}
        month={"numeric"}
        day={"numeric"}
        hour={"numeric"}
        minute={"numeric"}
      />;
  }
  return <ReactIntl.FormattedDate
    value={value}
    weekday={"long"}
    hour={"numeric"}
    minute={"numeric"}
  />;
}

let make = FormattedDateTimeShort;

export {
  make,
}
/* react-intl Not a pure module */
